export default "__VITE_ASSET__OemM6TkQ__"